/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  
  app.ItemPage = app.Model.extend({
    defaults: {
      wtfPageArray: [],
      itemLinkPage: []
    },
    
    saveWtfId: function (wtfId, link) {
      this.attributes.wtfPageArray.push(wtfId);
      this.attributes.itemLinkPage.push(link);
    }
  });
})(jQuery);

}.call(window));